
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import RatingStars from '~/components/sections/rating/RatingStars.vue'

@Component({
  components: {
    RatingStars,
  },
})
export default class ProviderCommonCard extends Vue {
  @Prop({ required: false, default: false, type: Boolean })
  private readonly bordered!: boolean

  @Prop({ required: false, default: 'md', type: String })
  private readonly size!: string

  @Prop({ required: true, default: '', type: String })
  private readonly title!: string

  @Prop({ required: true, default: '', type: String })
  private readonly logo!: string

  @Prop({ required: true, default: 0, type: Number })
  private readonly score!: number

  @Prop({ required: true, default: 0, type: Number })
  private readonly reviews!: number
}
